import { useEffect } from 'react';

import { useAISmartButtonActions } from '@atlassian/ai-smart-button-api';
import { type DailyBriefUnread } from '@atlassian/ai-smart-button-api/daily-brief';

const DAILY_BRIEF_NAME_PREFIXES = ['daily brief:', 'get-daily-brief', '/get-daily-brief'];

type MostRecentUnread = { completedAt?: string | null; id: string; name: string | null } | null;

function toDailyBriefUnread(mostRecentUnread: MostRecentUnread): DailyBriefUnread {
	const lowerName = mostRecentUnread?.name?.toLowerCase() ?? '';
	const isDailyBrief = DAILY_BRIEF_NAME_PREFIXES.some((prefix) => lowerName.startsWith(prefix));

	if (!isDailyBrief || !mostRecentUnread) {
		return null;
	}

	return {
		conversationId: mostRecentUnread.id,
		name: mostRecentUnread.name,
		completedAt: mostRecentUnread.completedAt ?? null,
	};
}

/**
 * Syncs the most recent unread conversation to the daily brief store slot.
 */
export function useDailyBriefSync({
	enabled,
	mostRecentUnread,
}: {
	enabled: boolean;
	mostRecentUnread: MostRecentUnread;
}): void {
	const { setDailyBriefUnread } = useAISmartButtonActions();

	useEffect(() => {
		if (!enabled) return;
		setDailyBriefUnread(toDailyBriefUnread(mostRecentUnread));
	}, [mostRecentUnread, enabled, setDailyBriefUnread]);
}
